<template>
    <button
        class="button"
        :class="{ 'is-loading' : loading }"
        @click="onClick"
        type="button"
        :disabled="loading"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    name : "LoadingButton",
    props : {
        loading : {
            type : Boolean,
            required : true,
        },
    },
    methods : {
        onClick ($event) {
            if(this.loading){
                return;
            }
            this.$emit('click', $event);
        },
    },
}
</script>

<style scoped>
</style>
